import { designToken, quickProperty } from '../component-tokens';
const states = ['ui-background', 'ui-base-01', 'elevation-100', 'elevation-200', 'elevation-300', 'elevation-400'];
export const elevationTokens = {
    name: 'elevation',
    reactImports: 'Elevation',
    variants: states.map((state, i) => ({
        alias: state,
        name: state,
        content: ' ',
        tag: 'div',
        attributes: i === 0
            ? {
                'background-color': designToken(state),
            }
            : i === 1
                ? {
                    'border-color': designToken(state),
                    'border-width': quickProperty('1px'),
                    'border-style': quickProperty('solid'),
                }
                : {
                    'box-shadow': designToken(state),
                },
    })),
};
